import React from 'react';
import { useFormContext } from 'react-hook-form';

import { ScreenBodyShape as ScreenBodyShapeFemale } from '../../../OwnAI/screens/BodyShape';
import { ScreenBodyShape as ScreenBodyShapeMale } from '../../../OwnAIMan/screens/BodyShape';
import { LayoutDataType } from '../../types';

export const ScreenBodyShape: React.FC = () => {
  const form = useFormContext<LayoutDataType>();
  const gender = form.watch('gender');

  if (gender === 'male') {
    return <ScreenBodyShapeMale />;
  }

  return <ScreenBodyShapeFemale />;
};
